module.exports = __webpack_public_path__ + "img/boat-2.4d82428c.png";